import axios from 'axios';

    export const getDropdownAkunCategory = async () => {
        return await axios.get(`${window._HOST}admin/akun/categories/dropdown`, {withCredentials: true});
    }

    export const getAllDataTableAkunKategori = async (searchText = null, offset = 0, limit = 0, sortingCol = 0, sortingMode = 'DESC') => {
        if(searchText) {
            return await axios.get(`${window._HOST}admin/akun/categories/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
        } else {
            return await axios.get(`${window._HOST}admin/akun/categories/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
        }
    }

    export const insertNewAkunKategori = async (formData) => {
        return await axios.post(`${window._HOST}admin/akun/categories`, formData, {withCredentials: true});
    }

    export const updateAkunKategori = async (formData, id_akun_kategori) => {
        return await axios.put(`${window._HOST}admin/akun/categories/${id_akun_kategori}`, formData, {withCredentials: true});
    }

    export const deleteAkunKategori = async (id_akun_kategori) => {
        return await axios.delete(`${window._HOST}admin/akun/categories/${id_akun_kategori}`, {withCredentials: true});
    }